// @ts-nocheck
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { isActiveRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";
import { socket } from "../../../services/socket.io/socket.io.config";
import {
  emitDeviceHeartBeat,
  emitSocketEvent,
} from "../../../services/apiService";
import {
  SETUP_FAILURE,
  SETUP_SUCCESS,
} from "../../../store/constants/oneononemessaging";
import { ALERT_DIALOG } from "../../../store/constants/auth";
import { HEARTBEAT, SETUP } from "../groupMessaging/constants";
import { getUnreadMessagesEventAction } from "../../../store/actions/groupMessagingActions";

const useEmitUserId = () => {
  const dispatch = useDispatch();

  const auth = useSelector((store) => store.auth);

  // setInterval handle so we can clear on unmount / userId change
  const heartbeatRef = React.useRef<ReturnType<typeof setInterval> | null>(null);

  const setupHandler = async () => {
    const response = await emitSocketEvent({
      event: SETUP,
      payload: {
        _id: auth?.userId,
      },
    });

    if (response?.status === "ok") {
      dispatch({
        type: SETUP_SUCCESS,
      });

      // get unread messages
      dispatch(getUnreadMessagesEventAction());

      // Antes acumulava um setInterval por re-render (vazamento). Agora limpa
      // o anterior antes de registrar um novo.
      if (heartbeatRef.current) clearInterval(heartbeatRef.current);
      heartbeatRef.current = setInterval(() => {
        emitDeviceHeartBeat({ event: HEARTBEAT });
      }, 60000);
    } else {
      dispatch({
        type: SETUP_FAILURE,
      });

      // dispatch({
      //   type: ALERT_DIALOG,
      //   payload: {
      //     open: true,
      //     title: "Error!",
      //     message: "Some error occured in connecting to the server. Please reload the browser!"
      //   }
      // })
    }
  };

  React.useEffect(() => {
    if (isActiveRole(USER_ROLES.MARKETING)) {
      socket.disconnect();
      return;
    }
    if (!auth?.userId) {
      return;
    }

    if (socket) {
      setupHandler();
    }

    return () => {
      if (heartbeatRef.current) {
        clearInterval(heartbeatRef.current);
        heartbeatRef.current = null;
      }
    };
  }, [auth?.userId, auth?.activeRole]);
};

export { useEmitUserId };
